<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip-icon-comment)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.83333 15.2856C3.75493 15.2856 3.676 15.2679 3.60187 15.2326C3.59153 15.2275 3.58047 15.2222 3.5688 15.2166C3.37274 15.122 3.00471 14.9445 3.00471 14.7499C3.00471 14.7499 3 13.4999 3 12.9999C3 12.4999 3 11.9999 2 11.9999C1 11.9999 0 10.9999 0 9.99988V1.99988C0 0.999878 1 -0.00012207 2 -0.00012207H14C15 -0.00012207 16 0.999878 16 1.99988V9.99988C16 10.9999 15 11.9999 14 11.9999H8L4.16667 15.1683C4.07013 15.2459 3.95227 15.2856 3.83333 15.2856ZM3.55556 5.99988H12.4444C12.7517 5.99988 13 5.77588 13 5.49988C13 5.22388 12.7517 4.99988 12.4444 4.99988H3.55556C3.24833 4.99988 3 5.22388 3 5.49988C3 5.77588 3.24833 5.99988 3.55556 5.99988ZM3.5 8.07131H7.5C7.7765 8.07131 8 7.83131 8 7.53559C8 7.23988 7.7765 6.99988 7.5 6.99988H3.5C3.2235 6.99988 3 7.23988 3 7.53559C3 7.83131 3.2235 8.07131 3.5 8.07131Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip-icon-comment">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
name: "IconComment"
}
</script>

<style scoped>

</style>